import React from 'react'

const profileDetail = ({ user, t }) => {
    return <div className="container py-3">
        <div 
            className="text-dark font-weight-bold mb-4"
            style={{fontWeight: 'normal'}}
        >
            {t('Personal Information')}
        </div>

        <div className="card shadow rounded border-0">
            <div style={{padding: '1rem'}}>
                <strong>{t('Email')}</strong>
                <p className="text-muted">{user.email}</p>
            </div>
        </div>

        <div 
            className="text-dark font-weight-bold mb-4 mt-4"
            style={{fontWeight: 'normal'}}
        >
            {t('Assigned To')}
        </div>

        <div className="card shadow rounded border-0">
            <div style={{padding: '1rem'}}>
                <strong>{t('Client')}</strong>
                <p className="text-muted">{(user.site_associates && user.site_associates.length > 0) ? user.site_associates[0].site.client.name : 'Unassigned'}</p>
                <strong>{t('Site')}</strong>
                <p className="text-muted">
                {
                    (user.site_associates && user.site_associates.length > 0) && user.site_associates.map(site => (
                        <span key={site.site_id} className="badge badge-pill bg-brand text-white mr-1" >
                            { site.site.name }
                        </span>
                    ))
                }
                </p>
            </div>
        </div>
    </div>
}

export default profileDetail